
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop is a component that automatically scrolls the window to the top
 * whenever the pathname in the URL changes. This ensures that when a user navigates
 * to a new page, they start at the top of that page instead of maintaining their
 * scroll position from the previous page.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  // This component doesn't render anything
  return null;
};

export default ScrollToTop;
